import { toast } from "react-toastify";
import config from "../../config/index.json"

export async function nextStatusOrder(user, data) {
  let url = `${config.urlServer}/pdv/orders/${data?._id}/next-status-order`;
  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    uid: user.uid,
    tokenfirebase: user?.token_firebase,
    tokenbackend: user?.token_backend,
    email: user.email,
    restaurantid: user.restaurant_id,
    userpdvid: user.user_pdv_id,
    status: data.status
  };

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      // body: JSON.stringify(data),
    });

    if (response.status === 201 || response.status === 200) {
      const data = await response.json();
      // console.log(data);
      return data;
    } else {
      const data = await response.json();
      toast.error(data.error)

      console.log("Erro na requisição:", response.status, data.error)}

  } catch (err) {
    console.error("Erro na requisição:", err);
  }
  // Retorno padrão em caso de erro ou condição não satisfeita
  return null;
}
